import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Menu,
  MenuItem,
  withStyles,
} from '@material-ui/core';

import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import TenantForm from './Dialog/TenantForm';
import { clearLocalStorage, setSelectTenant } from '../../../utils/common';
import WarningForm from './Dialog/WarningForm';

const errMessage = {
  required: 'required_field',
};

class Tenant extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openMenu: null,
      dialogWarningForm: {
        id: null,
        name: null,
        open: false,
      },
      data: {
        name: '',
        locationId: null,
        usageType: '',
        address: '',
        district: '',
        province: '',
        postcode: '',
      },
      errorField: {
        name: {
          flag: false,
          msg: '',
        },
      },
    };
  }

  async componentDidMount() {
    const { locationId } = this.props.locations.toJS();
    await this.props.tenant.getTenantsByLocationId(locationId);
    this.props.wizard.resetFlow();
    console.log('componentDidMount from tenant');
  }

  onClickEdit(id) {
    const { t } = this.props;
    const { tenantsOfLocation } = this.props.tenant.toJS();
    const found = tenantsOfLocation.find((item) => item.id === id);
    if (found) {
      this.setState({
        open: true,
        data: {
          id: found.id,
          name: found.name,
          locationId: found.locationId,
          usageType: found.usageType
            ? {
                label: t(`${found.usageType}`),
                value: found.usageType,
              }
            : '',
          address: found.address,
          district: found.district
            ? {
                label: found.district,
                value: found.district,
              }
            : '',
          province: found.province
            ? {
                label: found.province,
                value: found.province,
              }
            : '',
          postcode: found.postcode
            ? {
                label: found.postcode,
                value: found.postcode,
              }
            : '',
        },
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  handleChangeProvince = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        province: e,
        district: '',
        postcode: '',
      },
    });
  };

  handleChangeDistrict = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        district: e,
        postcode: '',
      },
    });
  };

  handleChangePostCode = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        postcode: e,
      },
    });
  };

  handleChangeUsageType = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        usageType: e,
      },
    });
  };

  validate() {
    const { t } = this.props;
    const { data } = this.state;
    let checkName = !data.name ? true : false;

    this.setState({
      errorField: {
        name: {
          flag: checkName,
          msg: t(errMessage.required),
        },
      },
    });

    return !checkName;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: { flag: false, msg: '' },
        },
      });
    }
  }

  handleSubmitForm = async () => {
    const { locationId } = this.props.locations.toJS();
    let { data } = this.state;
    data = {
      id: data.id,
      name: data.name,
      locationId: locationId,
      usageType: data.usageType.value,
      address: data.address,
      district: data.district.value,
      province: data.province.value,
      postcode: data.postcode.value,
    };

    if (this.validate()) {
      if (data.id) {
        this.handleUpdate(data);
      } else {
        this.handleCreate(data);
      }
    }
  };

  handleCreate = async (data) => {
    const { t } = this.props;
    const { locationId } = this.props.locations.toJS();
    try {
      const result = await this.props.tenant.createTenant(data);
      if (result.statusCode === 200) {
        await this.props.tenant.getTenantsByLocationId(locationId);
        this.handleCloseForm();
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || `${t('failed_to_create')}`;
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
      }
    }
  };

  handleUpdate = async (data) => {
    const { t } = this.props;
    const { locationId } = this.props.locations.toJS();
    try {
      const result = await this.props.tenant.updateTenant(data);
      if (result.statusCode === 200) {
        await this.props.tenant.getTenantsByLocationId(locationId);
        this.handleCloseForm();
      }
    } catch (e) {
      if (e.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      } else if (e.statusCode === 400) {
        const msg = e.error.message || `${t('failed_to_update')}`;
        Swal.fire({ html: `<h4>${msg}`, type: 'error' });
      } else {
        Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
      }
    }
  };

  handleDelete = async (id) => {
    const { t } = this.props;
    const { dialogWarningForm } = this.state;
    if (dialogWarningForm.id) {
      try {
        const result = await this.props.tenant.deleteTenant(id);
        if (result.statusCode === 200) {
          this.handleCloseWarningForm();
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_remove')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_remove')}`, type: 'error' });
        }
      }
    }
  };

  handleOpendWarningForm = (id, name) => {
    this.setState({
      dialogWarningForm: {
        id,
        name,
        open: true,
      },
    });
  };

  handleCloseWarningForm = () => {
    this.setState({
      dialogWarningForm: {
        id: null,
        name: null,
        open: false,
      },
    });
  };

  handleBack = () => {
    const { activeStep } = this.props.wizard.toJS();
    this.props.wizard.backStep(activeStep);
  };

  handleClickGroup = () => {
    this.handleSetNavigation();

    const { activeStep } = this.props.wizard.toJS();
    this.props.wizard.nextStep(activeStep);
    this.props.wizard.setActiveFlow('group');
  };

  handleClickUser = () => {
    this.handleSetNavigation();

    const { activeStep } = this.props.wizard.toJS();
    this.props.wizard.nextStep(activeStep);
    this.props.wizard.setActiveFlow('user');
  };

  handleClickArea = () => {
    this.handleSetNavigation();

    const { activeStep } = this.props.wizard.toJS();
    this.props.wizard.nextStep(activeStep);
    this.props.wizard.setActiveFlow('area');
  };

  handleOpenForm = () => {
    this.setState({
      open: true,
      data: {
        name: '',
        locationId: null,
        usageType: '',
        address: '',
        district: '',
        province: '',
        postcode: '',
      },
    });
  };

  handleCloseForm = () => {
    this.setState({ open: false });
  };

  handleOpenMenu = async (event, tenantId, tenantName) => {
    this.setState({
      openMenu: event.currentTarget,
    });
    this.props.tenant.setAction('tenantId', tenantId);
    this.props.tenant.setAction('tenantName', tenantName);
  };

  handleCloseMenu = () => {
    this.setState({
      openMenu: null,
    });
  };

  handleSetNavigation = () => {
    const { tenantName, tenantId } = this.props.tenant.toJS();
    const { navigations, activeStep } = this.props.wizard.toJS();
    const nav = navigations;
    const data = {
      wizardStep: activeStep,
      wizardPage: 'tenant',
      wizardName: tenantName,
    };
    nav.push(data);
    this.props.wizard.setNavigation(nav);

    // set select tenant
    const tenantIds = [tenantId];
    setSelectTenant(tenantIds);
  };

  render() {
    const { classes, t } = this.props;
    const { tenantsOfLocation } = this.props.tenant.toJS();
    const { navigations } = this.props.wizard.toJS();

    return (
      <div>
        <Grid container>
          <Grid container item xs={12} sm={12} md={9}>
            <div className={classes.textHeader}>{t('wizard_tenant_for')}</div>
            <div className={classes.textHeaderPrimary}>{navigations[0].wizardName}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={3} className={classes.wrapButton}>
            <Button
              id='create'
              variant='contained'
              style={{
                backgroundColor: '#009D9A',
                color: '#fff',
                borderRadius: 8,
              }}
              onClick={this.handleOpenForm}
            >
              <div style={{ marginRight: 5 }}>
                <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#fff' }}>
                  <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                </svg>
              </div>
              {t('wizard_tenant_create')}
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
          <Paper className={classes.paperTable}>
            <div style={{ overflow: 'auto', maxHeight: '543px' }}>
              <Table>
                <TableHead>
                  <TableRow style={{ border: 'none' }}>
                    <CustomTableCell style={{ borderTopLeftRadius: '8px' }}>{t('wizard_tenant_name')}</CustomTableCell>
                    <CustomTableCell style={{ borderTopRightRadius: '8px' }}>{t('action')}</CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(tenantsOfLocation || []).map((tenant, i) => (
                    <TableRow key={i}>
                      <CustomTableCell component='th' scope='row' className={classes.widthBody}>
                        {tenant.name}
                      </CustomTableCell>
                      <CustomTableCell component='th' scope='row'>
                        <Grid container alignItems='center'>
                          <Button
                            id={`manage-${tenant.id}`}
                            variant='outlined'
                            color='primary'
                            style={{ marginRight: 10 }}
                            onClick={(e) => this.handleOpenMenu(e, tenant.id, tenant.name)}
                          >
                            {t('manage')}
                            <Icons.ArrowRight />
                          </Button>
                          <IconButton
                            id={`edit-${tenant.id}`}
                            className={classes.btnIcon}
                            onClick={() => this.onClickEdit(tenant.id)}
                          >
                            <svg width='24' height='24' viewBox='0 0 24 24'>
                              <use xlinkHref={`/images/menus-v1.svg#pencil`} />
                            </svg>
                          </IconButton>
                          <IconButton
                            id={`delete-${tenant.id}`}
                            className={classes.btnIcon}
                            onClick={() => this.handleOpendWarningForm(tenant.id, tenant.name)}
                          >
                            <svg width='24' height='24' viewBox='0 0 16 16'>
                              <use xlinkHref={`/images/menus-v1.svg#trash`} />
                            </svg>
                          </IconButton>
                        </Grid>
                      </CustomTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <Button id='back' variant='outlined' color='primary' onClick={this.handleBack} className={classes.btnPrimary}>
            {t('back')}
          </Button>
          <Button
            id='finish'
            variant='contained'
            color='primary'
            onClick={this.handleBack}
            className={classes.btnPrimary}
          >
            {t('wizard_finish')}
          </Button>
        </Grid>

        <TenantForm
          open={this.state.open}
          data={this.state.data}
          errorField={this.state.errorField}
          handleChange={this.handleChange}
          handleSubmitForm={this.handleSubmitForm}
          handleCloseForm={this.handleCloseForm}
          handleChangeProvince={this.handleChangeProvince}
          handleChangeDistrict={this.handleChangeDistrict}
          handleChangePostCode={this.handleChangePostCode}
          handleChangeUsageType={this.handleChangeUsageType}
        />

        <WarningForm
          open={this.state.dialogWarningForm.open}
          handleSubmitForm={this.handleDelete}
          handleCloseForm={this.handleCloseWarningForm}
          cancelButtonText={t('no')}
          confirmButtonText={t('confirm')}
          headerTitle={t('wizard_tenant_delete')}
          subTitle={t('wizard_tenant_delete_subtitle').replace('x', this.state.dialogWarningForm.name)}
        />

        <Menu
          id='selectManage'
          anchorEl={this.state.openMenu}
          open={Boolean(this.state.openMenu)}
          onClose={this.handleCloseMenu}
          className={classes.gridMenu}
          disableAutoFocusItem
        >
          <MenuItem id='group' onClick={() => this.handleClickGroup()}>
            <Typography>{t('wizard_step_unit')}</Typography>
          </MenuItem>
          <MenuItem id='user' onClick={() => this.handleClickUser()}>
            <Typography>{t('wizard_step_user')}</Typography>
          </MenuItem>
          <MenuItem id='area' onClick={() => this.handleClickArea()}>
            <Typography>{t('wizard_step_area')}</Typography>
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: 'rgba(230, 244, 243, 0.5)',
    color: theme.palette.text.header,
    border: 'none',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '200px',
    },
  },
  body: {
    fontSize: 16,
    borderTop: '1px solid #B8CFC3',
    borderBottom: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '400px',
    [theme.breakpoints.down('sm')]: {
      width: '600px',
    },
  },
}))(TableCell);

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '50%',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '70%',
    },
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'right',
    },
  },
  widthBody: {
    width: '700px',
    [theme.breakpoints.up('lg')]: {
      width: '900px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '500px',
    },
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  paperTable: {
    boxShadow: 'none',
    border: '1px solid #B8CFC3',
    borderRadius: '8px',
  },
  tableCellRadio: {
    width: '50px',
    padding: 4,
  },
  gridMenu: {
  },
  btnIcon: {
    marginRight: 10,
    borderRadius: 4,
    padding: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.bg,
    '&:hover': {
      fill: theme.palette.primary.bg,
      backgroundColor: theme.palette.primary.main,
    },
    '&:disabled': {
      fill: theme.palette.disable.main,
      backgroundColor: theme.palette.disable.light,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 5,
    },
  },
});

export const page = inject('wizard', 'locations', 'tenant')(observer(Tenant));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
